import { Component } from '@angular/core';
import ProductHelper from 'src/app/helpers/product-helper';
import { ProductTypeCriteriumService } from 'src/app/services/product-type-criterium-service';

@Component({
  selector: 'product-type-criterium-selector',
  templateUrl: './product-type-criterium-selector.component.html',
  styleUrls: ['./product-type-criterium-selector.component.scss'],
})
export class ProductTypeCriteriumSelectorComponent {
  typeOptions = ProductHelper.getTypeOptions();
  selectedTypeOptions: any[];

  constructor(
    private productTypeCriteriumService: ProductTypeCriteriumService
  ) {
    this.selectedTypeOptions =
      productTypeCriteriumService.getSelectedTypeOptions();
  }

  selectedTypeOptionsChange() {
    this.productTypeCriteriumService.selectedTypeOptionsChange(
      this.selectedTypeOptions
    );
  }

  compareTypeOptions(t1: any, t2: any): boolean {
    return t1 != null && t2 != null && t1 === t2;
  }
}
